import axios from 'axios';

import { bearerOverrideResponseInterceptor } from '#ui-shared/bootstrap/axios/bearer-override.response.interceptor';
import {
  convertDatesInRequestInterceptor,
  convertDatesInResponseInterceptor,
} from '#ui-shared/bootstrap/axios/date-convert.interceptor';
import { noraErrorHandlerResponseInterceptor } from '#ui-shared/bootstrap/axios/nora-error-handler.response.interceptor';
import { addAxiosRetry } from '#ui-shared/bootstrap/axios/retry';
import { setupWebViewInterceptors } from '#ui-shared/bootstrap/axios/webview.interceptor';
import { useAuthStore } from '#ui-shared/stores/auth-store';

export function configureAxiosToken(token?: string): void {
  if (!token) {
    delete axios.defaults.headers.common.Authorization;
  }
  else {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

/**
 * Will bootstrap Axios. Of note, it will enable HTTP interceptors if we are in WebView mode
 * @param inWebViewMode
 */
export async function bootstrapAxios(inWebViewMode = false): Promise<void> {
  if (inWebViewMode) {
    setupWebViewInterceptors(axios);
  }

  const authStore = useAuthStore();

  addAxiosRetry(axios);
  configureAxiosToken(authStore.token);

  authStore.$subscribe((store, state) => {
    configureAxiosToken(state.token);
  });

  axios.interceptors.response.use(
    bearerOverrideResponseInterceptor(),
    noraErrorHandlerResponseInterceptor(),
  );
  axios.interceptors.request.use(convertDatesInRequestInterceptor);
  axios.interceptors.response.use(convertDatesInResponseInterceptor);
}
